import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  switchTitle: {
    fontSize: '14px',
  },
  subtitle: {
    color: theme.palette.grey[400],
    fontSize: '14px',
  },
}));
